export class Question {
    public id: number = 0;
    public text?: string;
    public answerType?: string;
    public correctAnswer?: string;

    constructor(id: number, text?: string, answerType?: string, correctAnswer?: string) {
        this.id = id;
        this.text = text;
        this.answerType = answerType;
        this.correctAnswer = answerType === 'passfail' ? 'pass' : correctAnswer;
    }
}
